import { useRef } from 'react';
import { useInView } from '@/components/motion';

/** One continuous wave line, `periods` crests long, starting and ending on the waterline so it tiles seamlessly. */
function wavePath(periods: number, period: number, amp: number, y: number) {
  let d = `M0 ${y}`;
  for (let i = 0; i < periods; i++) d += ` q${period / 4} ${-amp} ${period / 2} 0 t${period / 2} 0`;
  return d;
}

const SWELL = wavePath(8, 150, 7, 14);
const SWELL_FAR = wavePath(6, 200, 5, 24);

/** Two-masted schooner (escuna) seen side-on, bow to the right. */
function Schooner() {
  return (
    <svg viewBox="0 0 64 44" fill="none" strokeLinejoin="round" strokeLinecap="round">
      <path className="footer-mark-sailcloth" d="M24 4 L13 8 L11 31 L24 31 Z M40 9 L31 12 L30 31 L40 31 Z M41 10 L60 31 L43 31 Z" />
      <path d="M24 3 V33 M40 8 V33 M58 33 L63 29" />
      <path d="M24 3.5 L29.5 5 L24 6.5" className="footer-mark-flag" />
      <path className="footer-mark-hull" d="M5 33 H59 L53 41 H11 Z" />
      <path d="M14 37 H50" className="footer-mark-trim" />
    </svg>
  );
}

/**
 * Footer sign-off: the brand name filled with moving sea water and a light sweep, a schooner sailing the
 * horizon in front of it, and a small radar/coordinates readout for Paraty. Animations pause off screen.
 */
export default function FooterWordmark() {
  const ref = useRef<HTMLDivElement>(null);
  const live = useInView(ref, { threshold: 0, rootMargin: '0px', once: false });

  return (
    <div ref={ref} className={`footer-mark${live ? ' is-live' : ''}`} aria-hidden="true">
      <div className="footer-mark-hud">
        <span className="footer-mark-coord">
          <i className="footer-mark-radar" />
          23°13′S · 44°43′W
        </span>
        <span className="footer-mark-scan" />
        <span>Paraty · RJ</span>
      </div>

      <div className="footer-mark-stage">
        <p className="footer-wordmark">AQUAMARINA</p>
        <div className="footer-mark-sea">
          <div className="footer-mark-swells">
            <svg className="footer-mark-swell" viewBox="0 0 1200 40" preserveAspectRatio="none">
              <path d={SWELL} />
            </svg>
            <svg className="footer-mark-swell footer-mark-swell--far" viewBox="0 0 1200 40" preserveAspectRatio="none">
              <path d={SWELL_FAR} />
            </svg>
          </div>
          <div className="footer-mark-voyage">
            <span className="footer-mark-boat">
              <Schooner />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
